import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Loader',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    innerText: {
      type: String,
      require: true
    },
    action: {
      type: String,
      require: true
    }
  },
  emits: {},
  setup() {
    return {};
  }
});